
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FieldOkComponent } from '@softline/dynamic';
import { Item } from '../../types/item';

import { IconComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-esl-item-list',
  imports: [FieldOkComponent,
    IconComponent,
    TranslatePipe],
  templateUrl: './esl-item-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./esl-item-list.component.css'] })
export class EslItemListComponent {
  readonly items = input.required<Item[]>();
  readonly itemCount = input.required<number>();

  removeItem = output<Item>();
  addItem = output<Item>();
  startScan = output();
  onSubmit = output();
}
